import { CloseCircle } from 'entities/close-circle/model'

import { Response } from 'shared/models/general.ts'

import { clientApi } from '../clientApi'

export const CloseCircleApi = {
  getUserDocuments() {
    return clientApi.get<Response<CloseCircle[]>>('/user-documents')
  },
  getUserDocumentsById(user_document_id: string) {
    return clientApi.get<Response<CloseCircle>>(
      `/user-documents/${user_document_id}`,
    )
  },
  setUserDocuments(data: CloseCircle) {
    return clientApi.post('/user-documents', data)
  },
  updateUserDocuments(data: CloseCircle, id: string) {
    return clientApi.patch(`/user-documents/${id}`, data)
  },
  deleteUserDocuments(id: string) {
    return clientApi.delete(`/user-documents/${id}`)
  },
}
